import React, { useRef } from 'react';
import ticketListActions from 'features/ticketList/services/actions';
import { useAppDispatch } from 'store/hooks';
import { IStaffItemData } from 'services/shop/types/staff';
import Button from 'components/Button';
import styled from 'styled-components';
import TrashV2 from 'assets/Icons/trashV2';
import { getMessageError, IResponseDataBody } from 'services/response';
import ticketListApis from 'features/ticketList/services/apis';
import toast from 'utils/toast';
import { FeatureVerify, OTPVerificationRef } from 'widgets/OTPVerification';
import { verifyAdminPW } from 'widgets/RequestAdminLocalPW/Callback';

interface IDeleteMultipleRevokedProps {
  selectedRowKeys: string[];
  onSuccess: () => void;
}

const DeleteMultiRevokedTicket = ({ selectedRowKeys, onSuccess }: IDeleteMultipleRevokedProps) => {
  const dispatch = useAppDispatch();

  const handleDeleteMultiRevokedTicket = async (staffId?: string) => {
    try {
      const res: IResponseDataBody = await ticketListApis.deleteMultipleRevokedTicket({
        billIds: selectedRowKeys,
        staffId: staffId || '',
      });

      if (res?.data?.data) {
        toast.success('Delete revoked ticket successfully');
        dispatch(ticketListActions.afterDeleteClosedTicket());
        onSuccess();
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Delete revoked ticket failed');
    }
  };

  const openDeleteRevokedModal = () => {
    OTPVerificationRef?.current?.openActiveSalon(async (valid) => {
      if (!valid) {
        verifyAdminPW(async (_pin?: string, data?: IStaffItemData) => {
          await handleDeleteMultiRevokedTicket(data?.id);
        });

        return;
      }

      await handleDeleteMultiRevokedTicket();
    }, FeatureVerify.DELETE_TICKET);
  };

  return (
    <Container>
      <Button
        ntype='PRIMARY'
        onClick={openDeleteRevokedModal}
        cardCashier
        height={3}
        iconElement={<TrashV2 fill='#FFF' />}
        disabled={selectedRowKeys.length === 0}
      >
        Delete
      </Button>
    </Container>
  );
};

export default DeleteMultiRevokedTicket;

const Container = styled.div`
  .CONTENT_2 {
    font-size: 22px;
    line-height: 1;
  }
`;
